import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import Input from './Input.jsx';
import Select from './Input2.jsx';
import IconButton from 'material-ui/IconButton';
import Search from 'material-ui/svg-icons/action/search';

const fieldProps = {
    fullWidth: true,
};

const RIFsearch = (props) => (
    <IconButton {...props}><Search/></IconButton>
);



const ProveedorForm = (props) => (
    <form>
        <div className="row">
            <div className="col-xs-12" style={{position:'relative'}}>
                <Input 
                validations="required,rif"
                {...fieldProps}
                val={props.proveedor.rif}
                onChange={props.handleChange} 
                floatingLabelText="Registro de Información Fiscal (R.I.F.)" 
                name="rif"
                debounce={400} />
                <RIFsearch 
                tooltip="Buscar datos en el SENIAT" 
                style={{position:'absolute', bottom:0, right:2}}
                onTouchTap={props.handleSearch.bind(this, props.proveedor.rif)}/>
            </div>

            


        </div>
        
        <Input 
        {...fieldProps}
        validations="required"
        val={props.proveedor.name}
        onChange={props.handleChange} 
        floatingLabelText="Nombre o Razón Social" 
        name="name"
        debounce={400} />

        <Input
        validations="required,decimal" 
        {...fieldProps}
        val={props.proveedor.percentage}
        onChange={props.handleChange} 
        floatingLabelText="Porcentaje (%) a Retener" 
        name="percentage"
        debounce={400} />

        <Select
            tipo="select"
            fullWidth={true}
            outerClassName="col-xs-12"
            name="tipo_proveedor"
            onChange={props.handleChange}
            validations="required"
            items={props.tipos_proveedor}
            val={props.proveedor.tipo_proveedor}
            floatingLabelText="Tipo de Proveedor"
            >
        
        </Select>
        <Input 
        validations="email"
        {...fieldProps}
        val={props.proveedor.email}
        onChange={props.handleChange} 
        floatingLabelText="Correo Electrónico (Opcional)" 
        name="email"
        debounce={400} />

        <Input 
        validations="alpha_dash"
        {...fieldProps}
        val={props.proveedor.phone}
        onChange={props.handleChange} 
        floatingLabelText="Teléfono (Opcional)" 
        name="phone"
        debounce={400} />

    </form>
);

export default ProveedorForm;


/** WEBPACK FOOTER **
 ** ./app-react/components/Forms/ProveedorForm.jsx
 **/